import React from 'react';
import InfoCard from "../../../../src/components/info-card.js";
export default {
  React,
  InfoCard
};